<template>
  <GenericReport
    ref="report"
    class="maxh-1bar clean-list"
    hide-header
    orientation="horizontal"
    :reportSpec="reportSpec"
    :adapterSpec="adapterSpec"
    :fetcher="fetchData"
    selectable
    @update:selected="(x) => (selectedIds = x)"
  >
    <template v-slot:topbar-actions>
      <v-spacer />
      <v-btn color="primary" @click="newGroup">
        Novo Grupo...
      </v-btn>
      <OMenuButton class="ml-2" :menuOpts="menuOpts" />
    </template>
  </GenericReport>

  <!-- <v-card-text class="pa-6">
        Estes são os grupos definidos na organização.
        Eles são usados tanto para veículos quanto para motoristas.
      </v-card-text> -->
</template>

<script>
import { OrgApi } from '@/models'
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import { iso } from 'oderon-commons/src/formatters'
import utils from 'oderon-commons/src/utils.js'

export default {
  expose: ['reload'],
  tabTitle: 'Grupos',
  components: {
    GenericReport
  },
  props: { value: { required: true } },
  data() {
    return {
      adapterSpec: [
        { t: 'Código', d: 'code' },
        { t: 'Criado em', d: 'createdAt', f: iso }
      ],
      reportSpec: {
        title: 'Grupos'
      },
      selectedIds: []
    }
  },
  computed: {
    menuOpts() {
      return [
        {
          text: 'Remover...',
          icon: 'mdi-delete',
          disabled: this.selectedIds.length < 1,
          onClick: () => this.confirmDelete()
        }
      ]
    }
  },
  watch: {
    value() {
      this.reload()
    }
  },
  methods: {
    reload() {
      this.$refs.report.reload()
    },

    async fetchData() {
      // Busca grupos de veículos mas são iguais aos de motoristas
      let fetcher = new OrgApi(this.value.id)
      let rows = await fetcher.get('vehicles/groups')
      rows.forEach((r) => (r.id = r.code)) // para ter um id único por linha
      return rows
    },

    async newGroup() {
      let label =
        'Digite o código do grupo. Use apenas letras, números e underscore.'
      let code = await this.$prompt({ label })

      if (!utils.isEmpty(code)) {
        // Cria nos dois.
        this.$rootLoading(async () => {
          code = code.trim()
          let fetcher = new OrgApi(this.value.id)
          await fetcher.post('vehicles/groups', { code })
          await fetcher.post('drivers/groups', { code })
          this.$snack('Salvo com sucesso')
          this.reload()
        })
      }
    },

    async confirmDelete() {
      let ok = await this.$confirmDelete({
        strings: 'grupo;o',
        len: this.selectedIds.length
      })

      if (ok) {
        this.$loading(async () => {
          let fetcher = new OrgApi(this.value.id)
          for (let code of this.selectedIds) {
            await fetcher.delete(`vehicles/groups/${code}`)
            await fetcher.delete(`drivers/groups/${code}`)
          }
          this.reload()
        })
      }
    }
  }
}
</script>

<style></style>
